/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPackageSubscriptions } from 'app/entities/package-subscription/package-subscription.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './package-payment-history.reducer';

export const PackagePaymentHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const packageSubscriptions = useAppSelector(state => state.packageSubscription.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const packagePaymentHistoryEntity = useAppSelector(state => state.packagePaymentHistory.entity);
  const loading = useAppSelector(state => state.packagePaymentHistory.loading);
  const updating = useAppSelector(state => state.packagePaymentHistory.updating);
  const updateSuccess = useAppSelector(state => state.packagePaymentHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/package-payment-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPackageSubscriptions({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }

    const entity = {
      ...packagePaymentHistoryEntity,
      ...values,
      subscription: packageSubscriptions.find(it => it.id.toString() === values.subscription?.toString()),
      paidBy: glucoUsers.find(it => it.id.toString() === values.paidBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...packagePaymentHistoryEntity,
          subscription: packagePaymentHistoryEntity?.subscription?.id,
          paidBy: packagePaymentHistoryEntity?.paidBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.packagePaymentHistory.home.createOrEditLabel" data-cy="PackagePaymentHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.packagePaymentHistory.home.createOrEditLabel">
              Create or edit a PackagePaymentHistory
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="package-payment-history-id"
                  label={translate('tinyMedicRestApp.packagePaymentHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.paymentMethod')}
                id="package-payment-history-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.transactionDetails')}
                id="package-payment-history-transactionDetails"
                name="transactionDetails"
                data-cy="transactionDetails"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.paidAmount')}
                id="package-payment-history-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.active')}
                id="package-payment-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.cursor')}
                id="package-payment-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.timestampentry')}
                id="package-payment-history-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.microSec')}
                id="package-payment-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.lastupdated')}
                id="package-payment-history-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.paidByFirstName')}
                id="package-payment-history-paidByFirstName"
                name="paidByFirstName"
                data-cy="paidByFirstName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.packagePaymentHistory.paidBySecondName')}
                id="package-payment-history-paidBySecondName"
                name="paidBySecondName"
                data-cy="paidBySecondName"
                type="text"
              />
              <ValidatedField
                id="package-payment-history-subscription"
                name="subscription"
                data-cy="subscription"
                label={translate('tinyMedicRestApp.packagePaymentHistory.subscription')}
                type="select"
              >
                <option value="" key="0" />
                {packageSubscriptions
                  ? packageSubscriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="package-payment-history-paidBy"
                name="paidBy"
                data-cy="paidBy"
                label={translate('tinyMedicRestApp.packagePaymentHistory.paidBy')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/package-payment-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PackagePaymentHistoryUpdate;
